import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Star(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.284c.345 0 .69.087 1.004.26l4.444 2.442c.122-.029.175-.086.157-.197l-.849-5.173a2.206 2.206 0 01.596-1.899l3.595-3.664c.074-.077.053-.17.041-.208-.03-.09-.08-.098-.098-.1l-4.97-.756a2.122 2.122 0 01-1.597-1.202L12.101 3.08c-.052-.109-.148-.108-.2 0L9.677 7.787A2.122 2.122 0 018.081 8.99l-4.97.755c-.017.003-.068.011-.098.101a.199.199 0 00.041.208l3.596 3.665c.486.495.708 1.205.595 1.898l-.849 5.174c-.018.111.035.167.067.19l4.535-2.436c.313-.173.657-.26 1.002-.26M6.511 23c-.42 0-.84-.13-1.202-.386a2.174 2.174 0 01-.887-2.147l.85-5.174a.206.206 0 00-.049-.174l-3.597-3.665a2.192 2.192 0 01-.51-2.24A2.123 2.123 0 012.81 7.766l4.97-.754c.034-.006.07-.037.09-.08l2.222-4.708A2.101 2.101 0 0112 1c.82 0 1.552.47 1.91 1.225l2.221 4.708c.021.043.055.074.09.08l4.97.754c.788.12 1.437.673 1.694 1.445a2.194 2.194 0 01-.51 2.241l-3.596 3.665a.208.208 0 00-.05.174l.85 5.174a2.176 2.176 0 01-.888 2.147 2.069 2.069 0 01-2.207.125l-4.444-2.442-4.524 2.442A2.07 2.07 0 016.511 23",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoStar = React.memo(Star);
export default MemoStar;